/* eslint-disable @typescript-eslint/no-explicit-any -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import classNames from "classnames/bind";
import { Loader } from "components/LegacyUI/Loader/Loader";
import ErrorSvg from "components/Svg/ErrorSvg";
import { ErrorMessages } from "pages/StuffingPage";
import { RootState } from "store";
import { IgnoreListContainer } from "./IgnoreList/IgnoreListContainer";
import { StuffingDetailed } from "./StuffingDetailed/StuffingDetailed";
import styles from "./Stuffing.module.scss";
const cn = classNames.bind(styles);

interface Stuffing {
  stuffingData: any;
  errorMessages: ErrorMessages[];
  pageHandler: (page: number) => void;
}

export const Stuffing: FC<Stuffing> = ({ stuffingData, errorMessages, pageHandler }) => {
  const { options } = useSelector((state: RootState) => state.root);
  const { t } = useTranslation();
  if (stuffingData) {
    return (
      <div className={styles["stuffing"]}>
        {stuffingData.ignors?.length > 0 ? <IgnoreListContainer ignoreItems={stuffingData.ignors} /> : null}

        {stuffingData.errors ? <p>{stuffingData?.errors?.message}</p> : null}

        {stuffingData.result?.length > 0 ? (
          <StuffingDetailed
            options={options}
            pageHandler={pageHandler}
            cargoesAttributes={stuffingData.cargoAttributes}
            stuffingData={stuffingData.result ? stuffingData.result : stuffingData}
          />
        ) : (
          <div />
        )}
      </div>
    );
  } else {
    return (
      <>
        {errorMessages.length ? (
          <div className={cn("Error")}>
            <ErrorSvg />

            <div className={cn("Error__body")}>
              {errorMessages.map((item, index) => (
                <div key={index} className={cn("Error__body-item")}>
                  {errorMessages.length > 1 ? <b>{item.group}:</b> : null}
                  <span>{item.message}</span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <Loader title={t("Container is loading...")} />
        )}
      </>
    );
  }
};
